import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';


export interface GetCollectionGroupDetailsVars {
    awsAccountId: String;
    collectionGroupId: String;
    collectionGroupName: String;
}

const GET_COLLECTION_GROUP_DETAILS = gql`
    query GetCollectionGroupDetails(
            $awsAccountId: String
            $collectionGroupId: String
            $collectionGroupName: String
        ){
        getCollectionGroupDetails(
            awsAccountId: $awsAccountId
            collectionGroupId: $collectionGroupId
            collectionGroupName: $collectionGroupName
        )
    }
`;

export const useGetCollectionGroupDetailsQuery = () => {
    return useLazyQuery<AnyObject, GetCollectionGroupDetailsVars>(GET_COLLECTION_GROUP_DETAILS, {
        errorPolicy: 'all',
    });
};
